function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createStitches } from '@stitches/react';
import BaseTokens from '@grupoboticario/flora-tokens/gbInstitucional/web/ds';
import { beautybox, belezanaweb, blzPro, boticario, eudora, gbInstitucional, oui, quemDisseBerenice, toqueto, vult, altoContraste, monocromatico, revendedores, casaMagalhaesOutono, casaMagalhaesNoite, casaMagalhaesCereja, casaMagalhaesAmazonia, casaMagalhaesOceano, associacaoGrupoBoticario, drJones, truss, fidelidadeOBoticario, fidelidadeQuemDisseBerenice, mooz } from './themes';
export var Tokens = BaseTokens;

var {
  media
} = Tokens,
    baseTheme = _objectWithoutPropertiesLoose(Tokens, ["media"]);

export var flora = createStitches({
  prefix: 'flora-',
  theme: baseTheme,
  media,
  utils: {
    p: value => ({
      padding: value
    }),
    pt: value => ({
      paddingTop: value
    }),
    pr: value => ({
      paddingRight: value
    }),
    pb: value => ({
      paddingBottom: value
    }),
    pl: value => ({
      paddingLeft: value
    }),
    px: value => ({
      paddingLeft: value,
      paddingRight: value
    }),
    py: value => ({
      paddingTop: value,
      paddingBottom: value
    }),
    m: value => ({
      margin: value
    }),
    mt: value => ({
      marginTop: value
    }),
    mr: value => ({
      marginRight: value
    }),
    mb: value => ({
      marginBottom: value
    }),
    ml: value => ({
      marginLeft: value
    }),
    mx: value => ({
      marginLeft: value,
      marginRight: value
    }),
    my: value => ({
      marginTop: value,
      marginBottom: value
    }),
    ta: value => ({
      textAlign: value
    }),
    fd: value => ({
      flexDirection: value
    }),
    fw: value => ({
      flexWrap: value
    }),
    ai: value => ({
      alignItems: value
    }),
    ac: value => ({
      alignContent: value
    }),
    jc: value => ({
      justifyContent: value
    }),
    as: value => ({
      alignSelf: value
    }),
    fg: value => ({
      flexGrow: value
    }),
    fs: value => ({
      flexShrink: value
    }),
    fb: value => ({
      flexBasis: value
    }),
    bc: value => ({
      backgroundColor: value
    }),
    br: value => ({
      borderRadius: value
    }),
    btrr: value => ({
      borderTopRightRadius: value
    }),
    bbrr: value => ({
      borderBottomRightRadius: value
    }),
    bblr: value => ({
      borderBottomLeftRadius: value
    }),
    btlr: value => ({
      borderTopLeftRadius: value
    }),
    bs: value => ({
      boxShadow: value
    }),
    lh: value => ({
      lineHeight: value
    }),
    ox: value => ({
      overflowX: value
    }),
    oy: value => ({
      overflowY: value
    }),
    pe: value => ({
      pointerEvents: value
    }),
    us: value => ({
      WebkitUserSelect: value,
      userSelect: value
    }),
    size: value => ({
      width: value,
      height: value
    }),
    linearGradient: value => ({
      backgroundImage: "linear-gradient(" + value + ")"
    }),
    appearance: value => ({
      WebkitAppearance: value,
      appearance: value
    }),
    userSelect: value => ({
      WebkitUserSelect: value,
      userSelect: value
    }),
    backgroundClip: value => ({
      WebkitBackgroundClip: value,
      backgroundClip: value
    }),
    fullscreen: value => ({
      position: value,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    })
  }
});
export var {
  config,
  css,
  getCssText,
  globalCss,
  keyframes,
  styled,
  theme
} = flora;
/**
 * @function
 * @name createTheme
 * @description Use for create a new theme from flora gbInstitucional
 * @tutorial https://flora.gb.tech/docs/overview/styling
 */

export var createTheme = flora.createTheme;
export var beautyboxTheme = createTheme('beautybox-theme', beautybox);
export var belezanawebTheme = createTheme('belezanaweb-theme', belezanaweb);
export var blzProTheme = createTheme('blz-pro-theme', blzPro);
export var boticarioTheme = createTheme('o-boticario-theme', boticario);
export var eudoraTheme = createTheme('eudora-theme', eudora);
export var gbInstitucionalTheme = createTheme('gb-institucional-theme', gbInstitucional);
export var toQueToTheme = createTheme('toqueto-theme', toqueto);
export var ouiTheme = createTheme('oui-theme', oui);
export var quemDisseBereniceTheme = createTheme('quem-disse-berenice-theme', quemDisseBerenice);
export var vultTheme = createTheme('vult-theme', vult);
export var altoContrasteTheme = createTheme('alto-contraste-theme', altoContraste);
export var monocromaticoTheme = createTheme('monocromatico-theme', monocromatico);
export var revendedoresTheme = createTheme('revendedores-theme', revendedores);
export var casaMagalhaesOutonoTheme = createTheme('casa-magalhaes-outono-theme', casaMagalhaesOutono);
export var casaMagalhaesNoiteTheme = createTheme('casa-magalhaes-noite-theme', casaMagalhaesNoite);
export var casaMagalhaesCerejaTheme = createTheme('casa-magalhaes-cereja-theme', casaMagalhaesCereja);
export var casaMagalhaesAmazoniaTheme = createTheme('casa-magalhaes-amazonia-theme', casaMagalhaesAmazonia);
export var casaMagalhaesOceanoTheme = createTheme('casa-magalhaes-oceano-theme', casaMagalhaesOceano);
export var associacaoGrupoBoticarioTheme = createTheme('associacao-grupo-boticario-theme', associacaoGrupoBoticario);
export var drJonesTheme = createTheme('dr-jones-theme', drJones);
export var trussTheme = createTheme('truss-theme', truss);
export var fidelidadeOBoticarioTheme = createTheme('fidelidade-o-boticario-theme', fidelidadeOBoticario);
export var fidelidadeQuemDisseBereniceTheme = createTheme('fidelidade-quem-disse-berenice-theme', fidelidadeQuemDisseBerenice);
export var moozTheme = createTheme('mooz-theme', mooz);
//# sourceMappingURL=flora.config.js.map